import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const SkillFilter = ({ 
  searchTerm, 
  onSearchChange, 
  selectedProficiency, 
  onProficiencyChange,
  selectedCategory,
  onCategoryChange,
  onClearFilters,
  categories 
}) => {
  const proficiencyOptions = [
    { value: '', label: 'All Levels' },
    { value: 'Expert', label: 'Expert' },
    { value: 'Advanced', label: 'Advanced' },
    { value: 'Intermediate', label: 'Intermediate' },
    { value: 'Beginner', label: 'Beginner' }
  ];

  const categoryOptions = [
    { value: '', label: 'All Categories' },
    ...categories.map(cat => ({ value: cat, label: cat }))
  ];

  const hasActiveFilters = searchTerm || selectedProficiency || selectedCategory;

  return (
    <div className="bg-card rounded-lg border border-border p-6 mb-8">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-text-primary flex items-center">
          <Icon name="Filter" size={20} className="mr-2" />
          Filter Skills
        </h3>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
            className="text-text-secondary hover:text-text-primary"
          >
            Clear Filters
          </Button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <Input
            type="search"
            placeholder="Search technologies..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full"
          />
        </div>

        <div>
          <Select
            placeholder="Filter by proficiency"
            options={proficiencyOptions}
            value={selectedProficiency}
            onChange={onProficiencyChange}
          />
        </div>

        <div>
          <Select
            placeholder="Filter by category"
            options={categoryOptions}
            value={selectedCategory}
            onChange={onCategoryChange}
          />
        </div>
      </div>

      {hasActiveFilters && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex flex-wrap gap-2">
            {searchTerm && (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-primary/10 text-primary">
                Search: "{searchTerm}"
                <button
                  onClick={() => onSearchChange('')}
                  className="ml-2 hover:text-primary/80"
                >
                  <Icon name="X" size={14} />
                </button>
              </span>
            )}
            {selectedProficiency && (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-secondary/10 text-secondary">
                Level: {selectedProficiency}
                <button
                  onClick={() => onProficiencyChange('')}
                  className="ml-2 hover:text-secondary/80"
                >
                  <Icon name="X" size={14} />
                </button>
              </span>
            )}
            {selectedCategory && (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-accent/10 text-accent">
                Category: {selectedCategory}
                <button
                  onClick={() => onCategoryChange('')}
                  className="ml-2 hover:text-accent/80"
                >
                  <Icon name="X" size={14} />
                </button>
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SkillFilter;